export const CAT_PRODUCTS = 'products';
export const CAT_PRODUCT_MARKET_COUNTRIES = 'product_market_countries';
export const CAT_SIMILAR_PRODUCTS = 'similar-products';
export const CAT_COMPANIES = 'companies';
export const CAT_BRANDS = 'brands';
export const CAT_PATENT_RESEARCH = 'patent_research';
export const CAT_TRADEMARKS = 'trademarks';
export const CAT_CONTACTS = 'contacts';
export const CAT_COMPONENTS = 'components';
export const CAT_PATENTS = 'patents';
export const CAT_NEWS = 'news';
export const CAT_COMPANY_NEWS = 'company_news';
export const CAT_AI_NEWS = 'ai_news';
export const CAT_REPORTSARCHIVE = 'reportsarchive';
export const CAT_STANDING_REPORTS = 'standing_reports';
export const CAT_STANDING_REPORTS_SECTIONS = 'standing_report_sections';
export const CAT_FILES = 'files';
export const CAT_PRODUCT_ORDERS = 'orders';
export const CAT_TRACKING_INFORMATION = 'tracking_informations';
export const CAT_COURIER_DELIVERY_SERVICES = 'courier_delivery_services';
export const CAT_WEBSITE_DEALS = 'website_deals';
export const CAT_INFO_REQUESTS = 'info_requests';
export const CAT_ANALYZE_REQUESTS = 'analyze_requests';
export const CAT_WEBSITE_SERVICES = 'website_services';
export const CAT_WEBSITES = 'websites';
export const CAT_STATUSES = 'statuses';
export const CAT_PROJECTS = 'projects';
export const CAT_AGENTS = 'agents';
export const CAT_RECOMMENDED_PRODUCTS = 'recommended_products';
export const CAT_ORDER_AGENTS = 'order_agents';
export const CAT_CUSTOMERS = 'customers';
export const CAT_BILLING_INFORMATION = 'billing_informations';
export const CAT_CONSUMABLE_VARIATIONS = 'consumable_variations';
export const CAT_VARIATIONS = 'product-variations';
export const CAT_TYPES = 'types';
export const CAT_SAMPLES = 'samples';
export const CAT_SAMPLE_CONDITIONS = 'sample_conditions';
export const CAT_FEATURES = 'features';
export const CAT_FEATURE_OPTIONS = 'feature_options';
export const CAT_ADDITIONAL_FIELD_NAMES = 'additional_field_names';
export const CAT_PATENT_LEGAL_EVENTS = 'patent_legal_events';

export const CAT_BRAND_STAFF_STATISTICS = 'brand_staff_statistics';
export const CAT_COMPANY_STAFF_STATISTICS = 'company_staff_statistics';
export const CAT_CONTACT_STAFF_STATISTICS = 'contact_staff_statistics';
export const CAT_PATENT_STAFF_STATISTICS = 'patent_staff_statistics';
export const CAT_PRODUCT_STAFF_STATISTICS = 'product_staff_statistics';
export const CAT_EVENT_STAFF_STATISTICS = 'event_staff_statistics';
export const CAT_NEWS_STAFF_STATISTICS = 'news_staff_statistics';
export const CAT_RESEARCHE_STAFF_STATISTICS = 'research_staff_statistics';
export const CAT_COMPONENTS_STAFF_STATISTICS = 'component_staff_statistics';
export const CAT_PATENT_RESEARCH_STAFF_STATISTICS = 'patent_research_staff_statistics';
export const CAT_TRADEMARKS_STAFF_STATISTICS = 'trademark_staff_statistics';

export const CAT_BRAND_STAFF_ITEM_STATISTICS = 'brand_staff_item_statistics';
export const CAT_COMPANY_STAFF_ITEM_STATISTICS = 'company_staff_item_statistics';
export const CAT_CONTACT_STAFF_ITEM_STATISTICS = 'contact_staff_item_statistics';
export const CAT_PATENT_STAFF_ITEM_STATISTICS = 'patent_staff_item_statistics';
export const CAT_PRODUCT_STAFF_ITEM_STATISTICS = 'product_staff_item_statistics';
export const CAT_EVENT_STAFF_ITEM_STATISTICS = 'event_staff_item_statistics';
export const CAT_NEWS_STAFF_ITEM_STATISTICS = 'news_staff_item_statistics';
export const CAT_RESEARCHE_STAFF_ITEM_STATISTICS = 'research_staff_item_statistics';
export const CAT_COMPONENTS_STAFF_ITEM_STATISTICS = 'component_staff_item_statistics';
export const CAT_TRADEMARKS_STAFF_ITEM_STATISTICS = 'trademark_staff_item_statistics';
export const CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS = 'patent_research_staff_item_statistics';
export const CAT_CPC_CLASSIFICATION = 'patents_cpc_classification';
export const CAT_IPC_CLASSIFICATION = 'patents_ipc_classification';

export const CAT_COMPONENT_PACKAGES = 'component_packages';
export const CAT_COMPONENT_CATEGORIES = 'component_categories';
export const CAT_USERS = 'users';
export const CAT_RESEARCHES = 'researches';
export const CAT_USERGROUPS = 'usergroups';
export const CAT_PROOF_REQUESTS = 'proof_requests';
export const CAT_NICE_CLASSES = 'nice_classes';
export const CAT_PATENT_CITATIONS = 'patent_citations';
export const CAT_PATENT_NOTES = 'patent_notes';
export const CAT_USER_FILTERS = 'user_filters';
export const CAT_PRODUCT_MARKETS = 'product_markets';
export const CAT_EVENTS = 'events';
export const CAT_ATTENDING_REQUESTS = 'attending_requests';
export const WIMS_REGISTRATION_DEAL_TYPE_ID = 61;
export const CAT_EVENT_TYPES = 'event_types';
export const CAT_EVENT_THEMES = 'event_themes';
export const CAT_ACTIVITY_SPHERES = 'activity_spheres';
export const CAT_INGREDIENT_CATEGORIES = 'ingredient_categories';
// Id of the root feature group whose children are the ingredient categories
export const FEATURE_GROUP_INGREDIENT_CATEGORY_ID = 1;
export const CAT_PRICE_SOURCE_TYPES = 'price_source_types';
// Social media scraper
export const CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM = 'social-media-scraper-instagram';
export const CAT_SOCIAL_MEDIA_SCRAPER_FACEBOOK = 'social-media-scraper-facebook';
export const CAT_SOCIAL_MEDIA_SCRAPER_X = 'social-media-scraper-x';
export const CAT_SOCIAL_MEDIA_SCRAPER_YOUTUBE = 'social-media-scraper-youtube';
export const CAT_SOCIAL_MEDIA_SCRAPER_LINKEDIN = 'social-media-scraper-linkedin';
export const CAT_SOCIAL_MEDIA_SCRAPER_ALL = 'social-media-scraper-all';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS = 'social-media-scraper-core-accounts';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_RESULTS = 'social-media-scraper-core-results';
export const CAT_SOCIAL_MEDIA_SCRAPER_CORE_SESSIONS = 'social-media-scraper-core-sessions';
export const CAT_NEWSLETTER_EMAILS = 'newsletter-emails';
export const CAT_NEWSLETTER_DOMAINS = 'newsletter-domains';
export const CAT_AI_NEWS_PROMPTS = 'ai_news_prompts';
export const CAT_INFORMATION_SOURCES = 'information_sources';
export const CAT_INFORMATION_SOURCE_SNAPSHOTS = 'information_source_snapshots';
export const CAT_GLOBAL_SEARCH = 'global_search';
export const CAT_AI_SEARCH = 'ai_search';

export const FILE_GROUP_MODULE_PRODUCTS = 1;
export const FILE_GROUP_MODULE_COMPANY = 2;

const SINGULAR_CATS = {
  [CAT_PRODUCTS]: 'product',
  assistant_products: 'product',
  [CAT_COMPANIES]: 'company',
  [CAT_BRANDS]: 'brand',
  [CAT_PATENT_RESEARCH]: 'patent_research',
  [CAT_TRADEMARKS]: 'trademark',
  [CAT_CONTACTS]: 'contact',
  [CAT_COMPONENTS]: 'component',
  [CAT_PATENTS]: 'patent',
  [CAT_NEWS]: 'news',
  [CAT_COMPANY_NEWS]: 'company news',
  [CAT_EVENTS]: 'event',
  [CAT_REPORTSARCHIVE]: 'reports archive',
  [CAT_STANDING_REPORTS]: 'standing report',
  [CAT_FILES]: 'file',
  [CAT_CONSUMABLE_VARIATIONS]: 'consumable variation',
  [CAT_ACTIVITY_SPHERES]: 'sphere of activity',
  [CAT_INGREDIENT_CATEGORIES]: 'ingredient category',
  [CAT_TYPES]: 'type',
  [CAT_VARIATIONS]: 'variation',
  [CAT_FEATURES]: 'feature',
  [CAT_EVENT_TYPES]: 'event type',
  [CAT_EVENT_THEMES]: 'event theme',
  [CAT_AI_NEWS_PROMPTS]: 'prompt',
  [CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS]: 'core account',
  [CAT_SAMPLES]: 'sample',
  [CAT_SAMPLE_CONDITIONS]: 'sample condition',
  [CAT_BRAND_STAFF_STATISTICS]: 'brand staff statistics',
  [CAT_COMPANY_STAFF_STATISTICS]: 'company staff statistics',
  [CAT_CONTACT_STAFF_STATISTICS]: 'contact staff statistics',
  [CAT_PATENT_STAFF_STATISTICS]: 'patent staff statistics',
  [CAT_PRODUCT_STAFF_STATISTICS]: 'product staff statistics',
  [CAT_EVENT_STAFF_STATISTICS]: 'event staff statistics',
  [CAT_NEWS_STAFF_STATISTICS]: 'news staff statistics',
  [CAT_COMPONENTS_STAFF_STATISTICS]: 'component staff statistics',
  [CAT_BRAND_STAFF_ITEM_STATISTICS]: 'brand staff item statistics',
  [CAT_COMPANY_STAFF_ITEM_STATISTICS]: 'company staff item statistics',
  [CAT_CONTACT_STAFF_ITEM_STATISTICS]: 'contact staff item statistics',
  [CAT_PATENT_STAFF_ITEM_STATISTICS]: 'patent staff item statistics',
  [CAT_PRODUCT_STAFF_ITEM_STATISTICS]: 'product staff item statistics',
  [CAT_EVENT_STAFF_ITEM_STATISTICS]: 'event staff item statistics',
  [CAT_NEWS_STAFF_ITEM_STATISTICS]: 'news staff item statistics',
  [CAT_RESEARCHE_STAFF_ITEM_STATISTICS]: 'research staff item statistics',
  [CAT_RESEARCHE_STAFF_STATISTICS]: 'research staff statistics',
  [CAT_COMPONENTS_STAFF_ITEM_STATISTICS]: 'component staff item statistics',
  [CAT_COMPONENT_PACKAGES]: 'component package',
  [CAT_COMPONENT_CATEGORIES]: 'component category',
  [CAT_USERS]: 'user',
  [CAT_RESEARCHES]: 'research',
  [CAT_USERGROUPS]: 'user group',
  [CAT_PRODUCT_ORDERS]: 'order',
  [CAT_CUSTOMERS]: 'customer',
  [CAT_COURIER_DELIVERY_SERVICES]: 'delivery service',
  [CAT_PROJECTS]: 'project',
  [CAT_AGENTS]: 'agent',
  [CAT_RECOMMENDED_PRODUCTS]: 'recommended product',
  [CAT_ORDER_AGENTS]: 'agent payments',
  [CAT_WEBSITE_SERVICES]: 'website service',
  [CAT_SOCIAL_MEDIA_SCRAPER_INSTAGRAM]: 'social media scraper instagram',
  [CAT_PATENT_RESEARCH_STAFF_ITEM_STATISTICS]: 'patent research staff item statistics',
  [CAT_PATENT_RESEARCH_STAFF_STATISTICS]: 'patent research staff statistics',
  [CAT_TRADEMARKS_STAFF_STATISTICS]: 'trademark staff statistics',
  [CAT_TRADEMARKS_STAFF_ITEM_STATISTICS]: 'trademark staff item statistics',
};

export function singularizeCat(cat) {
  return SINGULAR_CATS[cat] || cat;
}

// Unlike `singularizeCat`, an unknown category yields undefined instead of the raw key,
// so callers can tell a real label from a category name that would read as gibberish.
export function getSingularCat(cat) {
  return SINGULAR_CATS[cat];
}
